interface IconProps {
  fillColor: string
}

export const PinIntroEnpalIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45.4492 62.8724C46.0207 62.9304 46.4661 63.4132 46.4661 64C46.4661 64.5868 46.0207 65.0696 45.4492 65.1276L45.3333 65.1328H38.6667C38.0407 65.1328 37.5339 64.6259 37.5339 64C37.5339 63.3741 38.0407 62.8672 38.6667 62.8672H45.3333L45.4492 62.8724Z"
          fill={fillColor}
        />
        <path
          d="M57.4492 62.8724C58.0207 62.9304 58.4661 63.4132 58.4661 64C58.4661 64.5868 58.0207 65.0696 57.4492 65.1276L57.3333 65.1328H50.6667C50.0407 65.1328 49.5339 64.6259 49.5339 64C49.5339 63.3741 50.0407 62.8672 50.6667 62.8672H57.3333L57.4492 62.8724Z"
          fill={fillColor}
        />
        <path
          d="M69.4492 62.8724C70.0207 62.9304 70.4661 63.4132 70.4661 64C70.4661 64.5868 70.0207 65.0696 69.4492 65.1276L69.3333 65.1328H62.6667C62.0407 65.1328 61.5339 64.6259 61.5339 64C61.5339 63.3741 62.0407 62.8672 62.6667 62.8672H69.3333L69.4492 62.8724Z"
          fill={fillColor}
        />
        <path
          d="M81.4492 62.8724C82.0207 62.9304 82.4661 63.4132 82.4661 64C82.4661 64.5868 82.0207 65.0696 81.4492 65.1276L81.3333 65.1328H74.6667C74.0407 65.1328 73.5339 64.6259 73.5339 64C73.5339 63.3741 74.0407 62.8672 74.6667 62.8672H81.3333L81.4492 62.8724Z"
          fill={fillColor}
        />
        <path
          d="M83.5469 41.1328C84.2828 41.1332 84.8799 41.7302 84.8802 42.4661C84.8802 43.2023 84.283 43.7991 83.5469 43.7995C82.8105 43.7995 82.2135 43.2025 82.2135 42.4661C82.2138 41.73 82.8107 41.1328 83.5469 41.1328Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.3333 34.8672C88.1684 34.8672 90.4661 37.1649 90.4661 40V73.5339H92.8333L93.069 73.5456C94.2285 73.6636 95.1328 74.6427 95.1328 75.8333C95.1328 78.3923 93.0589 80.4661 90.5 80.4661H29.5C26.9411 80.4661 24.8672 78.3923 24.8672 75.8333C24.8672 74.5631 25.8964 73.5339 27.1667 73.5339H29.5339V40C29.5339 37.1649 31.8316 34.8672 34.6667 34.8672H85.3333ZM27.1536 75.8021C27.1505 75.8034 27.1469 75.8062 27.1432 75.8099C27.1395 75.8136 27.1368 75.8172 27.1354 75.8203C27.1354 75.8203 27.1328 75.8266 27.1328 75.8333C27.1328 77.1404 28.1929 78.2005 29.5 78.2005H90.5C91.8071 78.2005 92.8672 77.1404 92.8672 75.8333C92.8672 75.8266 92.8646 75.8203 92.8646 75.8203C92.8632 75.8172 92.8605 75.8136 92.8568 75.8099C92.8531 75.8062 92.8495 75.8034 92.8464 75.8021L92.8333 75.7995H66.4479C66.4595 75.8646 66.4661 75.9315 66.4661 76C66.4661 76.5868 66.0207 77.0696 65.4492 77.1276L65.3333 77.1328H54.6667C54.0407 77.1328 53.5339 76.6259 53.5339 76C53.5339 75.9315 53.5417 75.8647 53.5534 75.7995H27.1667C27.16 75.7995 27.1536 75.8021 27.1536 75.8021ZM34.6667 37.1328C33.0835 37.1328 31.7995 38.4168 31.7995 40V73.5339H88.2005V40C88.2005 38.4168 86.9165 37.1328 85.3333 37.1328H34.6667Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
